import type { WordpressTaxonomy } from "@gik/core/models/wordpress/WordpressTaxonomy";
import type { UIComponent } from "@gik/core/types/UI";
import { useBemCN } from "@gik/core/utils/bemBlock";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import { FlexGrid } from "@gik/ui-legacy/FlexGrid";
import { PageHeader } from "@gik/ui-legacy/gik/PageHeader";
import { HTMLParser } from "@gik/ui-legacy/HTMLParser";
import { Image } from "@gik/ui-legacy/Image";
import type React from "react";
import { useTranslation } from "react-i18next";
import translationKeys from "../../i18n/en";

export type GiveHeaderProps = {
	taxonomyItem?: WordpressTaxonomy;
} & UIComponent;

function GiveHeaderComp({ taxonomyItem }: GiveHeaderProps): React.ReactElement {
	const bem = useBemCN("give-header");
	const { t } = useTranslation();

	const title = taxonomyItem?.name;
	const imageUrl =
		taxonomyItem?.acf.taxonomy_svg_icon || taxonomyItem?.acf.tax_thumb_image;

	return (
		<PageHeader variant="aqua" decoration="foliage" {...bem()}>
			<FlexGrid {...bem("content")}>
				{imageUrl && <Image alt="image" src={imageUrl} {...bem("image")} />}
				<h1>
					<HTMLParser
						rawHtml={
							title !== null && title !== undefined
								? title
								: t(translationKeys.title)
						}
					/>
				</h1>
			</FlexGrid>
		</PageHeader>
	);
}

export const GiveHeader = withComponentErrorBoundary(GiveHeaderComp);
